import { useState, useEffect } from "react";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaClock,
  FaFacebookF,
  FaTimes,
  FaLinkedinIn,
  FaPinterestP,
  FaSearch,
  FaYoutube,
  FaTwitter,
  FaInstagram,
} from "react-icons/fa";
import { FaX, FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isTop, setIsTop] = useState(true); // Track if user is at top

  // Scroll listener to update isTop
  useEffect(() => {
    const handleScroll = () => {
      setIsTop(window.scrollY === 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "News & Events", path: "/news-events" },
    { name: "Contact Us", path: "/contact" },
  ];

  return (
    <nav className="w-screen fixed top-0 z-50 transition-all duration-300">
      {/* Top Bar */}
      <div className="bg-blue-600 text-white w-full flex flex-row justify-between sm:justify-center sm:justify-between items-center px-2 sm:px-8 py-2 text-xs sm:text-sm">
        <div className="flex flex-col sm:flex-row items-start gap-2 sm:gap-6 sm:mb-0">
          {/* <span className="flex items-center gap-1 ">
            <FaMapMarkerAlt />
            <span className=" inline">
              Unitech Cyber Park, Sector-39, Gurugram
            </span>
          </span> */}
          <span className="flex items-center gap-1 whitespace-nowrap">
            <FaEnvelope /> iebc@indoeuropeancouncil.eu
          </span>
        </div>
        <div className="flex flex-col sm:flex-row items-end gap-2 sm:gap-6">
          {/* <span className="flex items-center gap-1 whitespace-nowrap">
            <FaClock /> 9.10 am - 5.30 pm
          </span> */}
          <div className="flex items-center gap-3">
            <a
              href="https://www.facebook.com/IndoEUBusinessCouncil"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="flex items-center justify-center  hover:text-blue-700 transition"
            >
              <FaFacebookF size={16} />
            </a>
            <a
              href="https://x.com/IEBC123"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
              className="flex items-center justify-center  hover:text-blue-700 transition"
            >
              <FaXTwitter size={16} />
            </a>
            <a
              href="https://www.instagram.com/indoeuropeanbusinesscouncil/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="flex items-center justify-center  hover:text-blue-700 transition"
            >
              <FaInstagram size={16} />
            </a>
            <a
              href="https://www.youtube.com/@indoeuropeancouncil"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="flex items-center justify-center  hover:text-blue-700 transition"
            >
              <FaYoutube size={16} />
            </a>
            <a
              href="https://www.linkedin.com/company/indoeuropeanbusinesscouncil/?originalSubdomain=uk"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="flex items-center justify-center  hover:text-blue-700 transition"
            >
              <FaLinkedinIn size={16} />
            </a>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <div
        className={`relative flex items-center justify-between bg-white px-8 py-1 shadow transition-all duration-300 ${
          isTop ? "backdrop-blur-md bg-white/100" : "bg-white/100"
        }`}
      >
        <div className="w-1/3 flex items-center gap-2 justify-start">
          <span className="font-semibold text-lg text-gray-800">
            <span className="text-blue-600 text-3xl font-bold">
              <img src="/logo.avif" className="h-20 " />
            </span>
          </span>
        </div>

        <div className="w-full hidden md:flex items-center justify-center text-black gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className="hover:text-blue-600 font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
        </div>

        <div className="w-1/3 hidden md:flex items-center justify-end gap-4">
          <FaSearch className="text-lg cursor-pointer" />
          <Link
            to="/contact"
            className="bg-blue-600 text-white font-semibold rounded-lg px-6 py-2 text-center"
            onClick={() => setMobileMenuOpen(false)}
          >
            Get A Quote
          </Link>
     
        </div>

        <button
          className="md:hidden flex flex-col gap-1"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className="block w-7 h-1 bg-gray-800 rounded"></span>
          <span className="block w-7 h-1 bg-gray-800 rounded"></span>
          <span className="block w-7 h-1 bg-gray-800 rounded"></span>
        </button>

        {mobileMenuOpen && (
          <div className="absolute top-full text-black left-0 w-full bg-white flex flex-col items-start px-8 py-4 shadow-lg z-50">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="py-2 w-full hover:text-blue-600 font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <div className="flex items-center gap-4 mt-4">
              <Link
                to="/contact"
                className="bg-blue-600 text-white font-semibold rounded-lg px-6 py-2 text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Get A Quote
              </Link>
         
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
